import React from "react"
import FormattedMessage from "@irati/utils/lang"
import ErrorText from "@irati/ui/src/ErrorText"
import {getErrorMessage, getErrorValues} from "@irati/utils/lang/formatError"

export default function FormattedErrorText({error}: {error: string | PBError}) {
  return (
    <ErrorText>
      {typeof error === "string" ? (
        <FormattedMessage id={error} />
      ) : (
        <FormattedMessage id={getErrorMessage(error)} values={getErrorValues(error)} />
      )}
    </ErrorText>
  )
}
